// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"ca5d1558","177":"9ce92c7c","201":"51ec39b7","215":"5ed2ccb2","268":"80857c34","350":"941c6a71"}[chunkId] + ".css";
};